/**
 * FinStat / registry often returns IČ DPH with legal note after comma, e.g.
 * "SK2022349714, podľa §4, registrácia od 19.4.2007" → "SK2022349714"
 */
export function normalizeIcDphValue(raw: string | null | undefined): string | null {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (!s) return null;
  const first = s.split(",")[0]?.trim() ?? "";
  return first || null;
}
